export default __webpack_public_path__ + "static/media/08.934bc73f.png";